export class DocumentWhitelistPayload {

    typeId:string;
    name:string;
    active:boolean;
    parentDocumentTypeName:string;
    
}